import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Subscription } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { SMARTBNB_API_V1 } from '../../interfaces/injection-tokens.interface';

export interface MonolithSecureApiKeyResponse {
  key: string;
  valid_until: {
    date: string; // weird format: 2022-10-24 16:44:48.941629
    timezone: string; // UTC
    timezone_type: number; // ??? 3
  };
}

@Injectable({
  providedIn: 'root',
})
export class AlgoliaService {
  private readonly smartbnbApiV1: string = inject(SMARTBNB_API_V1);
  algoliaSecureApiKey: MonolithSecureApiKeyResponse['key'] | null = null;

  refreshSubscription?: Subscription;
  keyLastRefreshedAt: Date | null = null;

  constructor(private http: HttpClient) {}

  public requestSecureAlgoliaKey() {
    return this.http.post<MonolithSecureApiKeyResponse>(`${this.smartbnbApiV1}/users/current/search-key`, {}).pipe(
      tap((res: MonolithSecureApiKeyResponse) => {
        if (res.key) {
          this.algoliaSecureApiKey = res.key;
          this.keyLastRefreshedAt = new Date();
        }
      }),
      map((res: MonolithSecureApiKeyResponse) => res.key)
    );
  }
}
